// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Vu","author":"e_Wu","container":"e_Xu","image":"e_Yu","uiHolder":"e_Zu"};